export const HSMS_SHARED_DATA_INVALIDATED_EVENT = 'hsms-shared-data-invalidated';

const VALID_HSMS_SLICES = new Set([
	'courses',
	'teachers',
	'classrooms',
	'students',
	'pullout_groups',
	'departments',
	'sections',
	'subsections',
	'labels',
	'lunchInfo',
	'scheduleInfo',
	'scheduleStructureData',
	'periods',
]);

const DATA_SAVE_SLICE_MAP = {
	course: ['courses', 'students', 'sections'],
	teacher: ['teachers', 'sections'],
	classroom: ['classrooms', 'sections'],
	student: ['students'],
};

const DATA_DELETE_SLICE_MAP = {
	course: ['courses', 'students', 'sections'],
	teacher: ['teachers', 'sections'],
	classroom: ['classrooms', 'sections'],
	student: ['students', 'sections'],
};

const SETTINGS_SLICE_MAP = {
	school_settings: ['scheduleInfo'],
	schedule_type: ['scheduleInfo'],
	lunch_structure: ['lunchInfo'],
	schedule_structure: ['scheduleStructureData', 'lunchInfo'],
	department: ['departments'],
};

export const normalizeHSMSSlices = (slices = []) => {
	if(!Array.isArray(slices)) return [];

	return [...new Set(slices.filter((slice_name) => VALID_HSMS_SLICES.has(slice_name)))];
};

export const getHSMSSlicesForMutation = ({
	mutation_type = null,
	data_type = null,
} = {}) => {
	if(mutation_type === 'save_data') return normalizeHSMSSlices(DATA_SAVE_SLICE_MAP[data_type] || []);
	if(mutation_type === 'delete_data') return normalizeHSMSSlices(DATA_DELETE_SLICE_MAP[data_type] || []);
	if(mutation_type === 'settings') return normalizeHSMSSlices(SETTINGS_SLICE_MAP[data_type] || []);

	return [];
};

export const dispatchHSMSDataInvalidation = ({
	school_id = null,
	schedule_version_id = null,
	data_version_id = null,
	slices = [],
	targets = null,
	reason = null,
} = {}) => {
	if(typeof window === 'undefined' || !window.dispatchEvent) return;

	const normalized_slices = normalizeHSMSSlices(slices);
	if(normalized_slices.length === 0) return;

	window.dispatchEvent(new CustomEvent(HSMS_SHARED_DATA_INVALIDATED_EVENT, {
		detail: {
			school_id,
			schedule_version_id,
			data_version_id,
			slices: normalized_slices,
			targets,
			reason,
		}
	}));
};

export const notifyHSMSDataMutation = ({
	school_id = null,
	schedule_version_id = null,
	data_version_id = null,
	mutation_type = null,
	data_type = null,
	slices = null,
	targets = null,
	reason = null,
} = {}) => {
	const next_slices = normalizeHSMSSlices(
		Array.isArray(slices) ? slices : getHSMSSlicesForMutation({mutation_type, data_type})
	);

	if(next_slices.length === 0) return;

	dispatchHSMSDataInvalidation({
		school_id,
		schedule_version_id,
		data_version_id,
		slices: next_slices,
		targets,
		reason: reason || `${mutation_type || 'mutation'}:${data_type || 'unknown'}`,
	});
};
